const FAKE_PAIRING_CODE = "*-*$-$";

export const isDummmyPairingCode = (code: string) => {
  return code === FAKE_PAIRING_CODE;
};
